import styled, { css } from 'styled-components';
import COLORS from '../../constants/colors.js';
import zIndexList from '../../constants/zIndexList.js';
import { VIEWPORT_OFFSET_TOP_CSS, VIEWPORT_KEYBOARD_INSET_CSS } from '../../methods/viewportSheet.js';

const FullViewportSheetStack = styled.div `
    position: fixed;
    inset: 0;
    z-index: ${zIndexList.bottomSheet};
    pointer-events: none;
`;
const FullViewportSheetOverlay = styled.div `
    position: absolute;
    inset: 0;
    pointer-events: auto;
    touch-action: none;
    background-color: rgba(10, 15, 30, 0.35);

    ${({ blurBackground }) => blurBackground
    ? css `
                  backdrop-filter: blur(10px);
                  -webkit-backdrop-filter: blur(10px);
              `
    : ""}
`;
const FullViewportSheetPanel = styled.div `
    position: absolute;
    left: 0;
    right: 0;
    /**
     * Both edges anchored, so the sheet fills the viewport whatever its content height.
     * The bottom stops at the keyboard rather than the screen, which keeps the sticky footer
     * on screen in browsers that leave the layout viewport full-height when the keyboard opens.
     */
    top: ${VIEWPORT_OFFSET_TOP_CSS};
    bottom: ${VIEWPORT_KEYBOARD_INSET_CSS};
    pointer-events: auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;

    ${({ borderRadius }) => borderRadius || borderRadius === 0
    ? css `
                  border-top-left-radius: ${borderRadius}px;
                  border-top-right-radius: ${borderRadius}px;
              `
    : css `
                  border-top-left-radius: 8px;
                  border-top-right-radius: 8px;
              `}
`;
const FullViewportSheetCrossIconWrapper = styled.div `
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${COLORS.GREY_200};
    border-radius: 50%;
    width: 36px;
    height: 36px;
    margin-left: auto;
    min-width: 36px;
`;
const FullViewportSheetSectionWrapper = styled.div ``;

export { FullViewportSheetCrossIconWrapper, FullViewportSheetOverlay, FullViewportSheetPanel, FullViewportSheetSectionWrapper, FullViewportSheetStack };
//# sourceMappingURL=FullViewportBottomSheet.styles.js.map
